import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=1a5462ce&scoped=true&"
import script from "./MemberEdit.vue?vue&type=script&lang=js&"
export * from "./MemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5462ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5462ce')) {
      api.createRecord('1a5462ce', component.options)
    } else {
      api.reload('1a5462ce', component.options)
    }
    module.hot.accept("./MemberEdit.vue?vue&type=template&id=1a5462ce&scoped=true&", function () {
      api.rerender('1a5462ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket/MemberEdit.vue"
export default component.exports